import { DragEvent, useRef } from "react"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { ITimelineDot, SELECT_CURSOR } from "src/modules/pe-landing-module/data/interfaces"

/* Protopia Ecosystem component */
export interface IVerticalTimelineAmplitudeHandlerProps {
    dots: ITimelineDot
    cursor: SELECT_CURSOR
}
const VerticalTimelineAmplitudeHandler = (props: IVerticalTimelineAmplitudeHandlerProps): JSX.Element => {
    const ref               = useRef(null)
    const isStartDrag       = useSyncState<boolean>(false)
    const startDragPos      = useSyncState<number>(props.dots?.amplitude || 0)
    const amplitude         = useSyncState<number>(props.dots?.amplitude || 0)

    const onDragStart = (event:DragEvent) => {   
        event.dataTransfer.setDragImage(event.currentTarget, window.outerWidth, window.outerHeight) 
        isStartDrag.set( true ) 
        startDragPos.set( event.clientX - amplitude.get() ) 
    }
    const onDrag = ( event: DragEvent ) => { 
        if( !!isStartDrag.get() ) {
            if(amplitude.get() < 0 || amplitude.get() > 220) {
                return 
            }
            const left          = event.clientX  - startDragPos.get();
            amplitude.set(left)
            //const position      = { ...selectedData.data?.position, top, left }
        }
    }
    const  onDragEnd = ( event: DragEvent ) => { 

        isStartDrag.set( false )
    }
    return <div className='pe-vertical-timeline-amplitude-handler-container'>
        <div className="vt-amplitude-handler"
            draggable
            onDragStart={onDragStart}
            onDrag={onDrag}
            onDragEnd={onDragEnd}
            ref={ref}
        ></div>
    </div>
}
export default VerticalTimelineAmplitudeHandler